import type React from 'react'

import { useFirebaseUser } from '@/auth/useFirebaseUser.ts'
import { AppLoading } from '@/components/organisms/AppLoading/AppLoading.tsx'
import { AdminBreakersProvider } from '@/model/contexts/AdminBreakersProvider.tsx'

import { RegionProvider } from '../../model/contexts/RegionProvider.tsx'
import { useLoadingRegion } from '../../model/contexts/useRegion.ts'
import { useTeams } from '../../model/contexts/useTeams.ts'
import { useTransportRequests } from '../../model/contexts/useTransportRequests.ts'

const AppModelDataLoading: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { region } = useLoadingRegion()
  const { loading: transportRequestLoading } = useTransportRequests()
  const { loading: teamLoading } = useTeams()

  if (!region) {
    return <AppLoading />
  }

  if (region.currentOperatingDate && (transportRequestLoading || teamLoading)) {
    return <AppLoading />
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}

export const AppModelDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useFirebaseUser()

  if (!user) {
    return <AppLoading />
  }

  const centralId =
    new URLSearchParams(document.location.search).get('central_id') ?? import.meta.env.VITE_PILOTE_CENTRAL_ID
  return (
    <AdminBreakersProvider>
      <RegionProvider regionId={user.regionId} centralId={Number(centralId)}>
        <AppModelDataLoading>{children}</AppModelDataLoading>
      </RegionProvider>
    </AdminBreakersProvider>
  )
}
